import validate from "/builds/weplaybig/platform/big-front/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/builds/weplaybig/platform/big-front/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/builds/weplaybig/platform/big-front/middleware/admin.ts"),
  auth: () => import("/builds/weplaybig/platform/big-front/middleware/auth.ts"),
  company: () => import("/builds/weplaybig/platform/big-front/middleware/company.ts"),
  freelance: () => import("/builds/weplaybig/platform/big-front/middleware/freelance.ts"),
  organization: () => import("/builds/weplaybig/platform/big-front/middleware/organization.ts")
}